import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { InfiniteScrollGridResponse, ReviewLogLookupDto, SuccessResponse } from '@interfaces/central-monitoring';
import { ObservationType } from '@interfaces-clean/observations.interface';
import {
    BulkUpdateStudyReviewLog,
    CreateStudyReviewLog,
    DeleteStudyReviewLog,
    UpdateStudyReviewLog,
} from '@interfaces-clean/review-logs.interface';

import { getData, postData } from '@apis/rest-client';

const studyReviewLogUrl = 'CentralMonitoring/StudyReviewLog';

const StudyReviewLogsApi = {
    useSave: (studyRef: string) => {
        return useSWRMutation(
            `${studyReviewLogUrl}/Add/${studyRef}`,
            (url: string, { arg }: { arg: CreateStudyReviewLog }) => {
                return postData<CreateStudyReviewLog, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${studyReviewLogUrl}/Update/${studyRef}`,
            (url: string, { arg }: { arg: UpdateStudyReviewLog }) => {
                return postData<UpdateStudyReviewLog, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useDelete: (studyRef: string) => {
        return useSWRMutation(
            `${studyReviewLogUrl}/Delete/${studyRef}`,
            (url: string, { arg }: { arg: DeleteStudyReviewLog }) => {
                return postData<DeleteStudyReviewLog, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
    useBulkUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${studyReviewLogUrl}/bulkUpdate/${studyRef}`,
            (url: string, { arg }: { arg: BulkUpdateStudyReviewLog }) => {
                return postData<BulkUpdateStudyReviewLog, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
    useGet: (studyRef: string) => {
        return useSWRMutation(`${studyReviewLogUrl}/${studyRef}`, (url: string, { arg }: { arg: string }) => {
            return getData<InfiniteScrollGridResponse>(`${url}/${arg}`, { timeout: 30000 });
        });
    },
    useLookupReviewLogsForObservation: (studyRef: string, observationId: string, observationType: ObservationType) => {
        const url =
            observationType === ObservationType.Study
                ? `${studyReviewLogUrl}/Get/${studyRef}/ReviewLogsForObservation/${observationId}`
                : null;

        return useSWR<ReviewLogLookupDto[]>(url, getData);
    },
};

export default StudyReviewLogsApi;
